import React from 'react';
import './Forms.css';

export default function Checkbox({ checked, funcCall }) {
	return <input className='chkBox' type='checkbox' checked={checked} onChange={(e) => funcCall(e)} />;
}
